export default [{ Title: "Golf" }, { Title: "Tennis" }, { Title: "Social" }];
